import React, { useEffect } from "react"
import { Icon, Label, Table } from "semantic-ui-react"
import { useGetPaginatedEventHistory } from "../../../Hooks/FetchHooks/GetDataService/getOrganizationData/useGetPaginatedEventHistory"
import BifrostTable from "../../BifrostElementComponent/BifrostTable/BifrostTable"

const BifrostEventComponent = ({ chosenItem, chosenItemType }) => {
	const { data, isLoading, pagination, setPagination, getEventHistory } = useGetPaginatedEventHistory(chosenItem, chosenItemType)

	const eventHeaderColumns = React.useMemo(
		() => [
			{ name: "Timestamp (UTC)", key: "timestamp", type: "date" },
			{ name: "Action", key: "type", type: "string" },
			{ name: "Done By", key: "username", type: "string" },
			{ name: "Details", key: "details", type: "string" }
		],
		[]
	)

	const typeColors = {
		login_success: "green",
		login_failed: "red",
		otp_generated: "yellow",
		reboot: "grey",
		fw_upgrade: "grey",
		session_start: "blue",
		terms_accepted: "olive",
		subnet_mapping_created: "olive",
		subnet_mapping_deleted: "orange"
	}

	const typeIcons = {
		login_success: "check",
		login_failed: "minus circle",
		otp_generated: "key",
		reboot: "redo",
		fw_upgrade: "arrow up",
		session_start: "play",
		terms_accepted: "paragraph",
		subnet_mapping_created: "sitemap",
		subnet_mapping_deleted: "ban"
	}

	const typeText = {
		login_success: "Login Success",
		login_failed: "Login Failed",
		otp_generated: "OTP Generated",
		reboot: "Reboot",
		fw_upgrade: "Firmware Upgrade",
		session_start: "Session Start",
		terms_accepted: "Terms Accepted",
		subnet_mapping_created: "Subnet Mapping Created",
		subnet_mapping_deleted: "Subnet Mapping Deleted"
	}

	const EventRow = ({ item }) => (
		<Table.Row key={item.timestamp}>
			<Table.Cell>{item.timestamp}</Table.Cell>
			<Table.Cell>
				<Label color={typeColors[item.type]}>
					<Icon name={typeIcons[item.type]} />
					{typeText[item.type]}
				</Label>
			</Table.Cell>
			<Table.Cell>{item.email}</Table.Cell>
			<Table.Cell>{item.details}</Table.Cell>
		</Table.Row>
	)

	const filterEvent = (event, filter) =>
		!filter || filter === ""
			? true
			: event.type.toLowerCase().includes(filter.toLowerCase()) ||
			  (event.username && event.username.toLowerCase().includes(filter.toLowerCase())) ||
			  event.timestamp.toLowerCase().includes(filter.toLowerCase()) ||
			  (event.details && event.details.toLowerCase().includes(filter.toLowerCase()))

	useEffect(() => {
		if (!data || !data.length) {
			getEventHistory(pagination)
		}
		// return () => setData([])
	}, [])

	return (
		<BifrostTable
			pageName="Events"
			loading={isLoading}
			data={data}
			columns={eventHeaderColumns}
			Row={EventRow}
			pagination={pagination}
			setPagination={setPagination}
			filterFunc={filterEvent}
			defaultSort={{ order: "descending", column: "timestamp" }}
			fetchData={getEventHistory}
		/>
	)
}

export default BifrostEventComponent
